export default __webpack_public_path__ + "static/media/7.cdbd7192.png";